import { useCoaches, useJamaicaCoaches } from '@/lib/hooks'
import { CoachesGrid } from '@/components/sections/CoachesGrid'
import { JamaicaMap } from '@/components/sections/JamaicaMap'
import { PageHero } from '@/components/layout/PageHero'
import { CosmosCrest } from '@/components/brand/CosmosCrest'
import { Reveal } from '@/components/motion/Reveal'

export function CoachesPage() {
  const { data: coaches = [] } = useCoaches()
  const { data: jamaica = [] } = useJamaicaCoaches()
  return (
    <>
      <PageHero
        eyebrow="Staff &amp; Coaching"
        title="The people on our sideline."
        intro="Licensed technical staff — USSF, CONCACAF, UEFA credentials. Every coach at Cosmos is background-checked and SafeSport certified."
        image="https://cosmosfc.org/wp-content/uploads/2022/03/C2-3.jpg"
        crumbs={[{ label: 'Staff' }]}
      />

      {/* Main staff */}
      <section className="py-20">
        <div className="container-narrow">
          <CoachesGrid coaches={coaches} />
        </div>
      </section>

      {/* Jamaica section — dark background so the coach cards read correctly */}
      <section className="py-24 bg-pitch-900 text-white relative overflow-hidden">
        <div
          aria-hidden
          className="absolute inset-0 pointer-events-none opacity-25 [background:radial-gradient(circle_at_15%_20%,rgba(28,168,74,0.35),transparent_50%),radial-gradient(circle_at_85%_75%,rgba(245,197,24,0.22),transparent_50%)]"
        />
        <div className="container-narrow relative">
          <div className="grid gap-10 md:grid-cols-[1fr_auto] items-center mb-10">
            <Reveal>
              <span className="eyebrow eyebrow-gold">Jamaica · Regional Coaches</span>
              <h2 className="mt-3 font-display text-display-3 uppercase leading-none">Cosmos F.C. Jamaica.</h2>
              <p className="mt-4 text-white/75 max-w-xl leading-relaxed">
                Six regional coaches operating in Kingston, St. Ann, St. Catherine, and St. Mary.
                Fun-first curriculum for ages 6-12, boys and girls.
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="hidden md:block">
                <CosmosCrest size={140} animated />
              </div>
            </Reveal>
          </div>
          <JamaicaMap coaches={jamaica} />
        </div>
      </section>
    </>
  )
}
